import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Tab from "../components/tab";
import {
  personal_information,
  save_personal_details,
  save_secret,
  generate_my_cv,
  updatePersonalInfo,
  sendOtp,
  personal_loading,
  resume_step_jump_function,
  returnHome,
  send_otp_loading,
  existing_resume,
} from "../../../Redux/ActionCreator";
import { convertJobInterests } from "../../../Redux/convertResume";
import { Deepseek_convertJobInterests } from "../../../Redux/DeepseekAI/convert"
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import SelectLanguage from "../../common/resumeLangSelection/selectLanguage";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";
// import { franc } from "franc-min";
// import langs from "langs"; // To get full language names

export default function PersonalInfoPage4({ nextStep, prevStep, setStep }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const info = useSelector((info) => info.personal_info);
  const profile = useSelector((e) => e.login);
  const userInfo = useSelector((e) => e.userInfo);
  const secret = useSelector((prev) => prev.secret);
  const p_profile = useSelector((e) => e.profile);
  const existingResume = useSelector(e => e.existingCV);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);


  const [jobTitle1, setJobTitle1] = useState("");
  const [jobTitle2, setJobTitle2] = useState("");
  const [jobTitle3, setJobTitle3] = useState("");

  const [showHeading1, setShowHeading1] = useState(false);
  const [showHeading2, setShowHeading2] = useState(false);
  const [showJobTitle1, setShowJobTitle1] = useState(false);
  const [showJobTitle2, setShowJobTitle2] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    if (info.message !== null) {
      // get the first and lastname only
      let interest = info.message?.JobInterests;
      setJobTitle1(interest !== undefined && interest?.length > 0 ? interest[0] : "");
      setJobTitle2(interest !== undefined && interest?.length > 1 ? interest[1] : "");
      setJobTitle3(interest !== undefined && interest?.length > 2 ? interest[2] : "");
    } else {
      let cacheInfo = getOneFromServerCache("personalInfo")
      cacheInfo.then(res => res.json())
        .then(res => {
          console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(personal_information(resObj));
              setJobTitle1(resObj.JobInterests[0])
              setJobTitle2(resObj.JobInterests[1])
              setJobTitle3(resObj.JobInterests[2])
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch(err => {
          // console.log("Error getting personal info", err)
        })
    }
  }, []);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showshowHeading1Timeout = setTimeout(() => setShowHeading1(true), 2500); // Matches Typewriter speed

    return () => clearTimeout(showshowHeading1Timeout);
  }, []);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    if (showHeading1 == true) {
      const showshowHeading2Timeout = setTimeout(() => setShowHeading2(true), 2500); // Matches Typewriter speed
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 100);

      return () => {
        clearTimeout(showshowHeading2Timeout),        
        clearTimeout(showButtomBTNTimeout)
      };
    }
  }, [showHeading1]);

  useEffect(() => {
    // Show last name label and input once first name is being typed
    if (jobTitle1?.length !== 0) {
      const showJobTitle1Timeout = setTimeout(() => setShowJobTitle1(true), 100);

      return () => clearTimeout(showJobTitle1Timeout);  
    }
  }, [jobTitle1]); // Runs only when firstName updates

  
  useEffect(() => {
    if (jobTitle2?.length !== 0) {
      // Show last name label and input once first name is being typed
      const showJobTitle2Timeout = setTimeout(() => setShowJobTitle2(true), 100);

      return () => {
        clearTimeout(showJobTitle2Timeout)
      };
    }
  }, [jobTitle2]); // Runs only when firstName 
  
  // useEffect(() => {
  //   if (jobTitle2.length !== 0) {
  //     // Show last name label and input once first name is being typed
  //     const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 100);

  //     return () => clearTimeout(showButtomBTNTimeout);
  //   }
  // }, [jobTitle2, showHeading2]); // Runs only when firstName updates

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (jobTitle1 !== "") {
        let personalInformation = {
          Firstname: info.message?.Firstname,
          LastName: info.message?.LastName,
          Address: info.message?.Address,
          Phone_number: info.message?.Phone_number,
          Email: info.message?.Email,
          Secret: secret.secret,
          JobInterests: [capitalize(jobTitle1)?.trim(), capitalize(jobTitle2)?.trim(), capitalize(jobTitle3)?.trim()],
          personalReviewed: true,
          interestsReviewed: true
        }
        dispatch(personal_information(personalInformation));
        // translate the job interest to the selected language on the background
        // dispatch(convertJobInterests({ JobInterests: [jobTitle1, jobTitle2, jobTitle3 ], Lang: [{lang: flowLanguage }] }, "resume" ));
        dispatch(
          convertJobInterests(
            {
              JobInterests: [jobTitle1, jobTitle2, jobTitle3],
              Lang: [{ lang: flowLanguage }],
            },
            "resume"
          )
        );
        // save into server cache
        await saveIntoServerCache("personalInfo", personalInformation);
        // now create the basic profile here.
        if (p_profile.message == null) {
          dispatch(save_personal_details(personalInformation, secret.secret, setStep));
        }
        setStep(6);
      } else {
        setTimeout(() => {
            toast.error("A least one job title is required", {
              position: toast.POSITION.TOP_RIGHT,
            });
        }, 50);
      }
    } catch (error) {
        throw error
    }
  }
  
  const [language, setLanguage] = useState("");
  // input character language detector
  const handleJobTitle1Change = (e) => {
    const inputText = e.target.value;
    setJobTitle1(inputText);

  };

  const handleJobTitle2Change = (e) => {
    const inputText = e.target.value;
    setJobTitle2(inputText);
  };

  const handleJobTitle3Change = (e) => {
    const inputText = e.target.value;
    setJobTitle3(inputText);

    // if (inputText.length > 3) {
    //   const langCode = franc(inputText);
    //   if (langCode !== "und") {
    //     const langName = langs.where("3", langCode)?.name || "Unknown";
    //     setLanguage(langName);
    //   } else {
    //     setLanguage("Unknown");
    //   }
    // } else {
    //   setLanguage("");
    // }
  };

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-screen flex justify-center ">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 lg:gap-0 mt-6 bg-white flex flex-col lg:gap-y-8 rounded-lg shadow-md p-6 md:p-8`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <Tab label="Personal Information" current={true} completed={false} num="1" />
            <Tab num="2" current={false} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Input Section with Animations */}
        <div className="flex justify-center w-full">
          <div className="flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center">
            
            <motion.p 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut" }} 
              className="lg:text-xl lg:text-2xl text-center text-[#5843BD] font-semibold notranslate"
            >
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["¿Qué tipo de empleo(s) estás buscando?"]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["What kind of job(s) are you looking for?"]} loop={1} typeSpeed={40} />
              )}
              {/* <Typewriter words={["What kind of job(s) are you looking for?"]} loop={1} typeSpeed={50} />               */}
            </motion.p>

            {showHeading1 && (
              <motion.p
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                className="text-base font-medium notranslate"
              >
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Ingresa hasta 3 cargos que te interesen."]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Please enter up to 3 job titles you're interested in"]} loop={1} typeSpeed={40} />
              )}
                {/* <Typewriter words={["Please enter up to 3 job titles you're interested in"]} loop={1} typeSpeed={50} />               */}
              </motion.p>
            )}

            <div className="flex w-full flex-col items-center">
              <div className="flex w-full max-w-[400px] flex-col items-center gap-4 justify-between">
                
                {/* Job Title 1 Input with Fade-Up & Typing Effect */}
                {showHeading2 && (
                  <motion.div 
                    initial={{ opacity: 0, y: 30 }} 
                    animate={{ opacity: 1, y: 0 }} 
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
                    className="flex w-full flex-col gap-y-2 vsm:mb-4 mb-0"
                  >
                    <label htmlFor="jobTitle1" className="text-black font-medium text-sm mb-2 notranslate">
                    {flowLanguage == "Spanish" ? (
                      <Typewriter key={flowLanguage} words={["Cargo 1"]} loop={1} typeSpeed={40} />
                    ) : (
                      <Typewriter key={flowLanguage} words={["Job title 1"]} loop={1} typeSpeed={40} />
                    )}
                      {/* <Typewriter words={["Job title 1"]} loop={1} /> */}
                    </label>
                    <input
                      type="text"
                      id="jobTitle1"
                      className="w-full max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                      value={jobTitle1}
                      onChange={(e) => handleJobTitle1Change(e)}
                      placeholder="e.g. Plumber"
                    />
                  </motion.div>
                )}

                {/* Job Title 2 Input with Fade-Up & Typing Effect */}
                {showJobTitle1 && (
                  <motion.div 
                    initial={{ opacity: 0, y: 30 }} 
                    animate={{ opacity: 1, y: 0 }} 
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                    className="flex w-full flex-col gap-y-2  vsm:mb-4 md:mb-0"
                  >
                    <label htmlFor="jobTitle2" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["Cargo 2"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["Job title 2"]} loop={1} typeSpeed={40} />
                      )}
                      {/* <Typewriter words={["Job title 2"]} loop={1} /> */}
                    </label>
                    <input
                      type="text"
                      id="jobTitle2"
                      className="w-full border-2 max-w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                      value={jobTitle2}
                      onChange={(e) => handleJobTitle2Change(e)}
                      placeholder="e.g. Cleaner"
                    />
                  </motion.div>
                )}

                {/* Job Title 3 Input with Fade-Up & Typing Effect */}
                {showJobTitle2 && (
                  <motion.div 
                    initial={{ opacity: 0, y: 30 }} 
                    animate={{ opacity: 1, y: 0 }} 
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
                    className="flex w-full flex-col gap-y-2"
                  >
                    <label htmlFor="jobTitle3" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["Cargo 3"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["Job title 2"]} loop={1} typeSpeed={40} />
                      )}
                      {/* <Typewriter words={["Job title 3"]} loop={1} /> */}
                    </label>
                    <input
                      type="text"
                      id="jobTitle3"
                      className="w-full border-2 max-w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                      value={jobTitle3}
                      onChange={(e) => handleJobTitle3Change(e)}
                      placeholder="e.g. Hvac Technician"
                    />
                  </motion.div>
                )}

              </div>
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4  vsm:px-6 px-8 rounded-md notranslate" key={flowLanguage}
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {flowLanguage == "Spanish" ? (
                        "ANTERIOR"
                      ) : (
                        "PREVIOUS"
                      )}
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4  px-6 rounded-md notranslate" key={flowLanguage}
                  >
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
    </div>
  );
}
